// extracted by mini-css-extract-plugin
module.exports = {"allResorts":"styles_allResorts__2tlux","resortsList":"styles_resortsList__3pFyu","btnViewAllResorts":"styles_btnViewAllResorts__12uob"};